import { render } from "./LoyaltySettings.vue?vue&type=template&id=4ded6446&scoped=true"
import script from "./LoyaltySettings.vue?vue&type=script&lang=js"
export * from "./LoyaltySettings.vue?vue&type=script&lang=js"

import "./LoyaltySettings.vue?vue&type=style&index=0&id=4ded6446&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ded6446"]])

export default __exports__